import {Component, OnInit} from '@angular/core';
import {BannerContentModel} from "../banner-content.model";
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BannerLayoutComponent} from "../../banner-layout.component";
import {BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {MyStorageService} from "../../../../services/common/my-storage.service";

@Component({
  selector: 'app-title-and-link-content',
  templateUrl: './title-and-link-content.component.html',
  styleUrls: ['./title-and-link-content.component.scss']
})
export class TitleAndLinkContentComponent extends BannerLayoutComponent<BannerContentModel> implements OnInit {
  title='';
  linkText='';
  link='';

  constructor(myStorageService:MyStorageService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService) {
    super( translationService, modalService, notificationService, myStorageService);
  }

  ngOnInit(): void {
    this.title = this.translate(this.data.title);
    this.linkText = this.translate(this.data.linkText);
    this.link = this.translate(this.data.link);
  }

  navigate() {
    alert(this.link);
  }


}
